import { z } from 'zod';

/**
 * AI-voorstel voor de werkplaatsinstructie (het instructiedeel van
 * products.assemblyInstruction), gebaseerd op de regels van de samenstelling.
 * Zie ook [[assemblyText]] voor het splitsen/samenvoegen met de lange omschrijving.
 */
export const SuggestAssemblyInstructionBodySchema = z.object({
  product_id: z.number().int().positive(),
});
export type SuggestAssemblyInstructionBody = z.infer<typeof SuggestAssemblyInstructionBodySchema>;

export const AssemblyInstructionSuggestionSchema = z.object({
  /**
   * Het voorgestelde instructiedeel: checklistregels (beginnend met '-') in het Klinger-
   * sjabloonformaat, gevolgd door productspecifieke montagestappen. De frontend parseert de
   * sjabloonpunten naar de formuliervelden; de rest wordt "Extra regels".
   */
  instruction: z.string(),
  /** Eén korte zin over gemaakte aannames, of null. */
  notes: z.string().nullable().optional(),
});
export type AssemblyInstructionSuggestion = z.infer<typeof AssemblyInstructionSuggestionSchema>;
